module.exports = "<div class=\"wrapper wrapper-content animated fadeInUp\"> <div class=ibox> <breadcrumb></breadcrumb> <iframe-template path-url={{url}} css=100% key=stateAnalysis></iframe-template> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/statistics/chartAnalysis/stateAnalysis/view/stateAnalysis.html
// module id = eImt
// module chunks = 0